/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import { TextField } from '@mui/material';
import React, { useContext } from 'react';

import { ElasticDslEntitlementContext } from './ElasticDslEntitlementContext';

interface IElasticDslQueryInputProps {
  disabled: boolean;
}

export const ElasticDslQueryInput = ({ disabled }: IElasticDslQueryInputProps) => {
  const { setQuery, query } = useContext(ElasticDslEntitlementContext);
  return (
    <TextField
      fullWidth
      value={query}
      onChange={(event) => setQuery(event.target.value)}
      placeholder="Add your lucene query"
      label="Query"
      error={disabled}
      helperText={disabled ? 'Please enter a valid lucence query' : ''}
      sx={{ fontFamily: 'monospace' }}
      required
    />
  );
};
